import { PhoneType } from "@/schema"
import { v4 as uuidv4 } from "uuid"
import { create } from "zustand"

export interface ClientFormData {
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneExtension: string
  phoneType: PhoneType
  createMore: boolean
  bookId?: string
}

interface ClientStore {
  drafts: Record<string, ClientFormData>
  createDraft: (defaultValues?: Partial<ClientFormData>) => string
  updateDraft: (id: string, updates: Partial<ClientFormData>) => void
  removeDraft: (id: string) => void
}

const DEFAULT_DRAFT: ClientFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  phoneExtension: "",
  phoneType: "mobile",
  createMore: false,
}

export const useClientStore = create<ClientStore>((set) => ({
  drafts: {},
  createDraft: (defaultValues?: Partial<ClientFormData>) => {
    const id = uuidv4()
    set((state) => ({
      drafts: {
        ...state.drafts,
        [id]: { ...DEFAULT_DRAFT, ...defaultValues },
      },
    }))
    return id
  },
  updateDraft: (id, updates) => {
    set((state) => {
      if (!state.drafts[id]) return state

      return {
        drafts: {
          ...state.drafts,
          [id]: {
            ...state.drafts[id],
            ...updates,
          },
        },
      }
    })
  },
  removeDraft: (id) => {
    set((state) => {
      const newDrafts = { ...state.drafts }
      delete newDrafts[id]
      return { drafts: newDrafts }
    })
  },
}))
